import React from "react";
import Button, { Variant } from "@components/buttons/Button/Button";
import PopupCard from "@components/modals/PopupCard/PopupCard";
import styles from "./ConfirmationPopup.module.css";

interface ConfirmationPopupProps {
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    message: string;
    confirmButtonText: string;
    variant: Variant;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
    visible, onConfirm, onCancel, message, confirmButtonText, variant,
}) => {
    return (
        <PopupCard visible={visible} onClose={onCancel}>
            <div className={styles.popupContent}>
                <h2>Confirmation Required</h2>
                <p>{message}</p>
                <div className={styles.buttonGroup}>
                    <Button variant="secondary" size="medium" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button variant={variant} size="medium" onClick={onConfirm}>
                        {confirmButtonText}
                    </Button>
                </div>
            </div>
        </PopupCard>
    );
};

export default ConfirmationPopup;
